import * as React from "react";
import type { SVGProps } from "react";
const SvgBlipDefault = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={6} /></svg>;
export default SvgBlipDefault;